import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Input } from '@/components/ui/input';

export const PasswordInput = ({ testid = 'password-input', className = '', ...props }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input {...props} type={show ? 'text' : 'password'} className={`pr-11 ${className}`} data-testid={testid} />
      <button type="button" onClick={() => setShow((s) => !s)} tabIndex={-1} aria-label={show ? 'Sembunyikan kata sandi' : 'Lihat kata sandi'} className="absolute right-3 top-1/2 -translate-y-1/2 rounded-md p-1 text-muted-foreground hover:text-foreground transition-colors" data-testid={`${testid}-toggle`}>
        {show ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
};
